import type { RichTextField } from '@/types/prismic'

export const hasText = (obj: any): obj is { text: string } => {
  return obj && typeof obj.text === 'string'
}

export const hasUrl = (obj: any): obj is { url: string } => {
  return obj && typeof obj.url === 'string'
}

function richTextNodeHasVisibleText(node: unknown): boolean {
  if (!node || typeof node !== 'object') return false
  const n = node as { text?: unknown; items?: unknown }

  if (typeof n.text === 'string' && n.text.trim().length > 0) {
    return true
  }

  if (Array.isArray(n.items)) {
    return n.items.some((item) => richTextNodeHasVisibleText(item))
  }

  return false
}

/** True when the field has at least one block (or nested list item) with non-empty trimmed `text`. */
export function richTextFieldHasVisibleText(field: RichTextField | null | undefined): boolean {
  if (!field || !Array.isArray(field)) return false
  return field.some((node) => richTextNodeHasVisibleText(node))
}

/** Sidebar `title` may be a plain string or Prismic rich text. */
export function hubSidebarTitleHasVisibleContent(title: string | RichTextField | null | undefined): boolean {
  if (title == null) return false
  if (typeof title === 'string') return title.trim().length > 0
  return richTextFieldHasVisibleText(title)
}
